import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

import { isMobile } from '../../../../lib/responsive';

import './AlertModal.less';

function AlertModal({ hideModalFn, modalContent }) {
  const { header, body } = modalContent;
  return (
    <div id="alert-modal">
      {header && <div className="modal-header">{header}</div> }
      <div className="modal-body">
        {body}
        <div className="modal-action">
          <ButtonV2
            variant="primary"
            fullWidth={isMobile()}
            onClick={hideModalFn}
          >
            Done
          </ButtonV2>
        </div>
      </div>
    </div>
  );
}

AlertModal.propTypes = {
  hideModalFn: PropTypes.func.isRequired,
  modalContent: PropTypes.shape({
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  }),
};

export default AlertModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/AlertModal/AlertModal.jsx